// Import firebase services
import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

export const UsersRepository = {

	/*
	**  Register the mixins
	*/

	mixins: [

		BugsnagService

	],

	/*
	**  Set up the data
	*/

	data: () => ({

		new_user: {
			id: null,
			type: 'user',
			meta: {
				app_id: '1:KA82LQU7lsJy:eKwkfzaQy4aM:HKUl9ACoGeAQ:j1xHCCBLS7UQ:yok9xA1wrkZi',
				created_at: moment().unix(),
				updated_at: moment().unix(),
				deleted_at: null,
				version: 1
			},
			attributes: {
				has_latest_version: true,
				subscription: {
					free_trial: {
						started_at: moment().unix(),
						ended_at: null,
						expired: false
					}
				},
				privacy_controls: {
					emails: {
						features: true,
						instructors: true,
						tips: true,
						updates: true,
					},
					profile: {
						instructors: true,
						courses: true
					},
					push_notifications: {
						web: true,
						ios: true,
						android: true,
						desktop: true,
						tvos: true
					}
				},
				profile: {
					about: 'This user hasn\'t written anything about themselves yet.',
					email: null,
					first_name: null,
					last_name: null,
					slug: null,
					username: null,
					avatar: null
				},
				terms_agreement: {
					opted_in: false,
					date: moment().unix()
				},
				role: {
					type: 1 // 1 = Standard
				}
			},
			links: {
				avatar: null,
				coverphoto: null,
				social_media_profiles: {
					facebook: null,
					twitter: null,
					instagram: null,
					linkedin: null,
					youtube: null,
					website: null
				}
			},
			relationships: {
				google: {
					access_token: null
				},
				apple: {
					access_token: null,
					id_token: null
				},
				company: null
			}
		}

	}),

	/*
	**  Set the methods
	*/

	methods: {

		createUser: function(uid) {

			// Create doc in database
			usersModel.doc(uid).set(this.new_user)
			.then(() => {

				// Hide the spinner
				this.hideSpinner();

				// Redirect to dashboard
				this.$router.push({ name: 'Dashboard' });

				// Throw success message
	    		this.$swal('Welcome!', 'Thank you for signing up!', 'success');

			})
			.catch(error => {

				// Hide the spinner
				this.hideSpinner();

				// Throw warning message
    			this.$swal('Uh Oh!', error, 'error');

    			// Send to bugsnag
				this.reportNoAuthBugsnagError({
					title: 'SISU - Save New User in Firestore',
					errorType: 'Firestore Database',
					section: 'SISU',
					component: 'SignUpForm',
					error: error
				});

			});

		},

		updateUserCompany: function() {

			// Update the user's company
			usersModel.doc(firebaseAuth.currentUser.uid).update({

				'relationships.company': this.new_company.id,
				'meta.updated_at': moment().unix()

			})
			.then(() => {

				// Hide the spinner
				this.hideSpinner();

				// Redirect to Company Settings page
				this.$router.push({ name: 'SettingsCompany' });

				// Throw success message
	    		this.$swal('Success!', 'Your company has been added to your profile.', 'success');

			})
			.catch(error => {

    			// Send to bugsnag
				this.reportAuthBugsnagError({
					title: 'Update User Company in Firestore',
					errorType: 'Firestore Database',
					section: 'UsersRepository',
					component: 'UsersRepository',
					error: error
				});

			});

		}

	}

}